export default {
  "http://localhost:3000": "",
  "https://connectedbuildings-dev.retail-azure.js-devops.co.uk":
    "53a815e8-4c1e-45fa-82c3-168a5f79155b",
  "https://connectedbuildings-stg.retail-azure.js-devops.co.uk":
    "4d923cba-1d23-45b0-9977-307948e054d2",
  "https://connectedbuildings-prod.retail-azure.js-devops.co.uk":
    "8219fb24-80c4-41c8-8654-d6caf5e40883",
  "https://bms.sainsburys.co.uk": "8219fb24-80c4-41c8-8654-d6caf5e40883"
};
